import axios from "axios";

export const MODULE_URL = "/Module";

/** Mevcut Kullanıcıyı Ait Yan Menü Listesini Elde Eder */
export function getAsideMenuList() {
  return axios.get(`${MODULE_URL}/GetAsideMenuList`);
}

/** Modül Listesini Elde Eder */
export function getModules() {
  return axios.get(MODULE_URL);
}

/** Belli Bir Modülü Elde Eder */
export function getModule(id) {
  return axios.get(`${MODULE_URL}/${id}`);
}

/** Belli Bir Modülü Kaydeder */
export function saveModule(module) {
  return axios.post(MODULE_URL, module);
}